import { createMuiTheme } from '@material-ui/core/styles';
import {PRIMARY_COLOR} from './constants/color';

const theme = createMuiTheme({
  overrides: {
    MuiCheckbox: {
      root: {
        color: `${PRIMARY_COLOR} !important`
      }
    },
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: `2px solid ${PRIMARY_COLOR}`
        },
        '&:before': {
          borderBottom: '1px solid #aaaaaa'
        },
        '&:hover': {
          borderBottom: 'transparent !important',
          borderBottomColor: 'transparent !important'
        },
        '&:hover:not($disabled):before': {
          backgroundColor: 'transparent !important',
          borderBottom: '1px solid #aaaaaa !important',
          borderColor: '#aaaaaa !important',
          color: 'none !important'
        }
      }
    },
    MuiRadio: {
      root: {
        color: '#1CABE2 !important'
      }
    },
    MuiSwitch: {
      bar: {
        backgroundColor: '#ccc !important'
      },
      checked: {
        color: `${PRIMARY_COLOR} !important`
      }
    }
  }
});

export default theme;


// WEBPACK FOOTER //
// ./src/app-theme.tsx